import * as React from 'react'
import { Link, } from 'react-router-dom';

import { PREMIUM_REPORTS, SECTION_NAME_TO_ICON_URL, iconLinkBase, } from './shared'

const DIAGNOSTIC_GROWTH_REPORT = 'Diagnostic Growth Report'

export const premiumReportTiles = [
  {
    name: 'Usage Snapshot Report',
    link: '/teachers/premium_hub/usage_snapshot_report',
    icon: `${iconLinkBase}/usage-snapshot-report.svg`,
    description: 'Key insights to help you succeed. View most assigned activities, average activities completed, and more.',
  },
  {
    name: DIAGNOSTIC_GROWTH_REPORT,
    link: '/teachers/premium_hub/diagnostic_growth_report',
    icon: `${iconLinkBase}/diagnostic-growth-report.svg`,
    description: 'Get a detailed breakdown of Quill’s impact on students’ growth. View data by skill, student, and more.',
  },
  {
    name: 'Skills Report',
    link: '/teachers/premium_hub/admin_skills_report',
    icon: `${iconLinkBase}/concepts-report.svg`,
    description: 'View student skill growth over time. Group data by skill, grade, teacher, or student, and review a complete practice history.',
    new: true
  },
  {
    name: 'Standards Report',
    link: '/teachers/premium_hub/admin_standards_report',
    icon: `${iconLinkBase}/standards-report.svg`,
    description: 'View student progress on state standards. Group data by standard, grade, teacher, or student, and pinpoint where to target support.',
    new: true
  },
  {
    name: 'Student Activity Data Export',
    link: '/teachers/premium_hub/data_export',
    icon: `${iconLinkBase}/data-export.svg`,
    description: 'Download a file containing all activities completed by students. Includes score, time spent, and more.',
  },
  {
    name: 'Activity Scores Report',
    link: '/teachers/premium_hub/district_activity_scores',
    icon: `${iconLinkBase}/activity-scores-report.svg`,
    description: 'View the overall average score for each student per class.',
  }
]

const PremiumReportsSection = () => {
  const tiles = premiumReportTiles.map(tile => {
    const buttonClassName = "quill-button outlined medium grey focus-on-light"
    const button = <Link aria-label={`View ${tile.name} report`} className={buttonClassName} to={tile.link}>View report</Link>
    return (
      <div className={`tile ${tile.new ? 'new' : ''}`} key={tile.name}>
        <div>
          <h3>{tile.name}{tile.new ? <span className="new-tag">NEW</span> : null}</h3>
          <p>{tile.description}</p>
        </div>
        <div className="link-and-image">
          {button}
          <img alt="" src={tile.icon} />
        </div>
      </div>
    )
  })

  return (
    <section aria-labelledby="premiumReportsSectionTitle" className="overview-section-wrapper premium-reports">
      <h2 id="premiumReportsSectionTitle">
        <img alt="" src={SECTION_NAME_TO_ICON_URL[PREMIUM_REPORTS]} />
        <span>{PREMIUM_REPORTS}</span>
      </h2>
      <div className="overview-section">
        <div className="overview-section-content">
          {tiles}
        </div>
      </div>
    </section>
  )
}

export default PremiumReportsSection
